import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

export const apkApi = createApi({
  reducerPath: "apk",
  tagTypes: ["APK"],
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      // Tum APK versiyonlarini listele
      getApkVersions: builder.query({
        query: (token) => ({
          url: "/api/apk-update/versions",
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
        providesTags: ["APK"],
      }),

      // Aktif APK versiyonunu getir
      getApkCurrentVersion: builder.query({
        query: (token) => ({
          url: "/api/apk-update/current",
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
        providesTags: ["APK"],
      }),

      // Presigned upload URL al
      getPresignedUploadUrl: builder.mutation({
        query: ({
          token,
          version,
          releaseNotes,
          targetModels,
          minCurrentVersion,
          maxCurrentVersion,
          targetSerialNos,
        }) => ({
          url: "/api/apk-update/upload/presign",
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: {
            version,
            releaseNotes,
            targetModels,
            minCurrentVersion,
            maxCurrentVersion,
            targetSerialNos,
          },
        }),
      }),

      // Upload tamamlandiktan sonra DB kaydi olustur
      confirmApkUpload: builder.mutation({
        query: ({
          token,
          storageKey,
          version,
          releaseNotes,
          fileSize,
          sha256Hash,
          targetModels,
          minCurrentVersion,
          maxCurrentVersion,
          targetSerialNos,
        }) => ({
          url: "/api/apk-update/upload/confirm",
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: {
            storageKey,
            version,
            releaseNotes,
            fileSize,
            sha256Hash,
            targetModels,
            minCurrentVersion,
            maxCurrentVersion,
            targetSerialNos,
          },
        }),
        invalidatesTags: ["APK"],
      }),

      // APK versiyonunun hedefleme seceneklerini guncelle
      updateApkVersion: builder.mutation({
        query: ({ token, id, ...body }) => ({
          url: `/api/apk-update/${id}`,
          method: "PATCH",
          headers: { Authorization: `Bearer ${token}` },
          body,
        }),
        invalidatesTags: ["APK"],
      }),

      // APK dosyasi icin indirme URL'i al (presigned)
      getApkDownloadUrl: builder.query({
        query: ({ token, id }) => ({
          url: `/api/apk-update/${id}/download`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
      }),

      // APK versiyonunu sil (DB + storage)
      deleteApkVersion: builder.mutation({
        query: ({ token, id }) => ({
          url: `/api/apk-update/${id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }),
        invalidatesTags: ["APK"],
      }),
    };
  },
});

export const {
  useGetApkVersionsQuery,
  useLazyGetApkVersionsQuery,
  useGetApkCurrentVersionQuery,
  useGetPresignedUploadUrlMutation,
  useConfirmApkUploadMutation,
  useUpdateApkVersionMutation,
  useLazyGetApkDownloadUrlQuery,
  useDeleteApkVersionMutation,
} = apkApi;
